export const StorageNames = {
  User: 'user',
  COMPANY: 'company',
  Companies: 'companies',
  SelectedCompany: 'selectedCompany',
  SelectedDateRange: 'selectedDateRange',

  TransactionsSelectedDateRange: 'transactionsSelectedDateRange',
  TransactionsParams: 'transactionsParams',
  SubscriptionsParams: 'susbcriptionsParams',
};
